
import { useOnboarding } from "@/hooks/useOnboarding";
import { Check, Circle } from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

export function StepProgressBar() {
  const { state, steps } = useOnboarding();
  const isMobile = useIsMobile();
  
  // Filter out substeps within steps
  const mainSteps = steps.filter(step => 
    !step.id.includes('step') || step.type !== 'multiStep'
  );
  
  return (
    <div className="w-full overflow-x-auto py-2 scrollbar-hide">
      <div className={cn(
        "flex items-center gap-1 min-w-max", 
        !isMobile && "px-4"
      )}>
        {mainSteps.map((step, index) => {
          const isCompleted = state.completedSteps.includes(step.id);
          const isCurrent = state.currentStepIndex === index;
          
          return (
            <div key={step.id} className="flex items-center">
              <motion.div
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                className={cn(
                  "flex items-center justify-center rounded-full transition-colors duration-300",
                  isCompleted ? "bg-green-100 text-green-600" : 
                  isCurrent ? "bg-primary/10 text-primary border border-primary/20" : 
                  "bg-slate-100 text-slate-400"
                )}
              >
                <div className="h-8 w-8 flex items-center justify-center">
                  {isCompleted ? (
                    <Check size={16} className="text-green-600" />
                  ) : (
                    <Circle size={isCurrent ? 16 : 14} className={cn(
                      isCurrent ? "fill-primary/10 text-primary" : "fill-slate-100 text-slate-400"
                    )} />
                  )}
                </div>
              </motion.div>
              
              {index < mainSteps.length - 1 && (
                <div className={cn(
                  "h-0.5 w-4 md:w-6", 
                  isCompleted ? "bg-green-200" : "bg-slate-200"
                )} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
